import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';

import type { GetReferralDashboardData } from '../graphql/queries/__generated__/GetReferralDashboardData';

type GetReferralDashboardData_organization = NonNullable<GetReferralDashboardData['organization']>;
import { OD_HOMEPAGE_URL } from '../helpers/globals';
import { ContentCard } from './ContentCard';
import { ContentWrapper } from './ContentWrapper';

interface IProps {
  organization: GetReferralDashboardData_organization;
}

const ProductEligibilitySection: React.FC<IProps> = ({ organization }) => {
  const getSafeReferralUrl = (url: string | null | undefined): string => {
    if (!url) {
      return OD_HOMEPAGE_URL;
    }
    try {
      const parsed = new URL(url);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
        return url;
      }
    } catch {
      // fall through
    }
    return OD_HOMEPAGE_URL;
  };

  const referralUrl = getSafeReferralUrl(organization.referralUrl);

  return (
    <ContentWrapper>
      <ContentCard title="Home Eligibility">
        <Text as="p" className="text-body-md">
          Check to see if a customer's home is eligible for an Opendoor offer.
        </Text>
        <Col className="pt-7">
          <Button
            variant="primary"
            className="w-full"
            href={referralUrl}
            analyticsName="partnership-dashboard-request-offer"
            aria-label="Request Offer"
          >
            Request Offer
          </Button>
        </Col>
      </ContentCard>
    </ContentWrapper>
  );
};

export { ProductEligibilitySection };
